// ES
export const reservasSmallHc = {
  createAlerta: {
    title: "Crear nuevo recordatorio",
    infoHeading: "Información del recordatorio",
    selectPropertyLabel: "Selecciona la propiedad que desea asignarle el recordatorio",
    dayLabel: "Selecciona un día de la semana:",
    dayMonday: "Lunes",
    dayTuesday: "Martes",
    dayWednesday: "Miércoles",
    dayThursday: "Jueves",
    dayFriday: "Viernes",
    daySaturday: "Sábado",
    daySunday: "Domingo",
    selectTimeLabel: "Seleccione la hora",
    sendAtLabel: "Se enviara a las:",
    minutesLabel: "Con {minutes} minutos:",
    previewPre: "La alerta sera enviada a los huéspedes los dias",
    previewMid: "a las",
    descriptionLabel: "Descripción de la alerta",
    descriptionPlaceholder: "Ingresa una descripción para la alerta",
    messageTypeLabel: "Seleccione el tipo de mensaje enviara.",
    messageTypeSimple: "Mensaje simple",
    messageTypeLink: "Mensaje con link al final",
    messageTypeFile: "Mensaje con archivo adjunto al final",
    linkFieldLabel: "Ingrese el link que se enviara con el recordatorio",
    fileFieldLabel: "Cargar archivo que se enviara con el recordatorio",
    fileNameLabel: "Nombre de archivo",
    cancel: "Cancelar",
    save: "Guardar recordatorio",
    errorDayRequired: "El dia es requerido",
    errorTimeRequired: "La hora es requerida",
    errorSelectMinutes: "Seleccione los minutos",
    errorDescriptionRequired: "La descripción es requerida",
    errorAttachmentRequired: "El contenido adjunto es requerido o seleccione que el tipo de mensaje sea simple",
  },
  reservationData: {
    statusConfirmed: "Confirmado",
    statusRejected: "Rechazado",
    statusTentative: "Sujeto a disponibilidad",
    statusWithinCheckin: "Dentro del horario de entrada",
    statusFree: "Sin coste",
    modalTitleApprove: "¿Aprobar la solicitud?",
    modalTitleApproveTime: "¿Aprobar a otra hora?",
    modalTitlePrioritize: "¿Priorizar esta entrada?",
    modalTitleReject: "¿Rechazar la solicitud?",
    modalTitleDefault: "¿Confirmar?",
    modalTextApprove: "Vas a aprobar la entrada anticipada de",
    modalTextApproveTime: "Confirmarás la entrada a la hora que indiques para",
    modalTextPrioritize: "Le diremos que haréis todo lo posible por tenerlo listo a esa hora, aunque depende de la salida anterior y de la limpieza. Se le enviará a",
    modalTextReject: "Vas a rechazar la entrada anticipada de",
    modalTextDefault: "Confirmar para",
    modalCtaApprove: "Sí, aprobar",
    modalCtaApproveTime: "Confirmar hora",
    modalCtaPrioritize: "Sí, informar",
    modalCtaReject: "Sí, rechazar",
    modalCtaDefault: "Confirmar",
    kpiRoom: "Habitación",
    kpiLodging: "Alojamiento",
    guestsCount: "huésped | huéspedes",
    adultsCount: "adulto | adultos",
    childrenCount: "niño | niños",
    infantsCount: "bebé | bebés",
    roomsCountValue: "{count} habitaciones",
    holderRole: "Titular de la reserva",
    noEmail: "Sin email asignado",
    writeWhatsapp: "Escribir por WhatsApp",
    noPhoneTitle: "Sin teléfono no se puede enviar por WhatsApp. Puedes añadirlo en «Editar reserva».",
    noPhone: "Sin teléfono asignado",
    kpiCheckin: "Entrada",
    kpiCheckout: "Salida",
    earlyRequested: "Early check-in solicitado",
    arrivalRequested: "Hora de llegada solicitada",
    arrivesAt: "Llega a las {time}",
    actionApprove: "Aprobar",
    actionOtherTime: "Otra hora",
    actionPrioritize: "Priorizar",
    actionReject: "Rechazar",
    awaitingPayment: "Esperando el pago del huésped",
    cannotUndo: "Esta acción no se puede deshacer.",
    checkinTimeLabel: "Hora de entrada",
    earlyPrioritisedTitle: "Early check-in priorizado",
    earlyApprovedTitle: "Early check-in aprobado",
    earlyRejectedTitle: "Early check-in rechazado",
    earlyLineApproved: "Llegará a las {time}",
    earlyLineApprovedOther: "Llegará a las {time} · pidió las {original}",
    earlyLineRejected: "Pidió las {time} · entrará a la hora habitual",
    earlyLineRejectedStd: "Pidió las {time} · entrará a la hora habitual ({std})",
    earlyLinePrioritised: "Quiere llegar a las {time} · le dijimos que haremos lo posible",
    extRequestedTitle: "Ampliación de estancia solicitada",
    extAwaitingTitle: "Ampliación de estancia esperando el pago",
    extConfirmedTitle: "Ampliación de estancia confirmada",
    extNights: "Noches añadidas: {nights} · nueva salida el {date}",
    extAtProperty: "{amount} a pagar en el alojamiento",
    extPendingHost: "esperando tu aprobación",
    lateRequestedTitle: "Salida tardía solicitada",
    lateAwaitingTitle: "Salida tardía pendiente de pago",
    lateConfirmedTitle: "Salida tardía confirmada",
    lateRejectedTitle: "Salida tardía rechazada",
    lateLeavesAt: "Saldrá a las {time}",
    lateWantsToLeave: "Quiere salir a las {time}",
    lateInsteadOf: "(en vez de a las {std})",
    latePaid: "Pagada: {amount}",
    lateCourtesy: "Hora de cortesía, sin coste",
    lateFree: "Sin coste",
    lateCash: "{amount} en efectivo a la salida",
    lateUnpaid: "{amount}, sin pagar todavía",
    lateLineRejected: "Pidió salir a las {time} · sale a su hora",
    lateLineRejectedStd: "Pidió salir a las {time} · sale a su hora ({std})",
    requestedTimeHint: "El huésped pidió las {time}",
    toastApproved: "Entrada anticipada aprobada",
    toastApprovedTime: "Nueva hora de entrada aprobada",
    toastPrioritised: "Entrada anticipada priorizada",
    toastRejected: "Entrada anticipada rechazada",
    toastNotified: "Ya le hemos escrito al huésped.",
    toastNotNotified: "No se pudo avisar al huésped: escríbele tú.",
    toastAlreadyDecided: "Esta solicitud ya estaba decidida: no se le ha vuelto a escribir al huésped.",
    toastError: "No se pudo guardar la decisión. Inténtalo de nuevo.",
    toastAlreadyPaid: "Ya estaba pagada: no se le ha cobrado otra vez.",
    toastRefundMaybeDue: "Había pagado por entrar antes y ahora entra a la hora normal: si corresponde, devuélveselo.",
    actionReadyNow: "Ya puede entrar",
    actionNotPossible: "No va a ser posible",
    toastPaymentLinkFailed: "No se pudo crear el enlace de pago: cóbraselo de otra forma.",
    arrivalApprovedTitle: "Hora de llegada confirmada",
    arrivalRejectedTitle: "Hora de llegada rechazada",
    arrivalLineRejected: "Pidió llegar a las {time}",
    modalTextApproveArrival: "Vas a confirmar la hora de llegada de",
    modalTextRejectArrival: "Vas a rechazar la hora de llegada de",
    toastArrivalApproved: "Hora de llegada confirmada",
    toastArrivalRejected: "Hora de llegada rechazada",
    cancel: "Cancelar",
  },
  minStayModal: {
    summaryNoData: "Sin datos en el rango seleccionado",
    summaryHintMixed: "Se detectaron varias estancias mínimas en el rango. El campo se carga en 1 noche para que definas el nuevo valor.",
    summaryHintSingle: "El campo se cargó con la estancia mínima actual del rango seleccionado.",
    errorMinOne: "La estancia mínima debe ser al menos 1 noche.",
    opStartLabel: "Cambiando estancia mínima…",
    successUpdated: "Estancia mínima actualizada correctamente",
    errorUpdate: "Error al actualizar la estancia mínima",
    errorUnknown: "Error desconocido",
    title: "Estancia mínima",
    description: "Configura la estancia mínima de noches para el rango de fechas seleccionado.",
    detectedLabel: "Estancias mínimas detectadas",
    minStayLabel: "Estancia mínima (noches)",
    decreaseAria: "Disminuir estancia mínima",
    minNightsPlaceholder: "Ej: 2",
    increaseAria: "Aumentar estancia mínima",
    hint: "Número mínimo de noches que debe reservar el huésped.",
    cancel: "Cancelar",
    save: "Guardar",
  },
  modalCompleteReservation: {
    errorContactRequired: "Para poder continuar debe llenar uno de los dos campos (teléfono o correo electrónico)",
    successMsg: "Datos de la reserva completados con éxito",
    successTitle: "Proceso realizado con éxito",
    title: "Completar reserva",
    bookingDateLabel: "Fecha de la reserva",
    checkin: "Entrada",
    checkout: "Salida",
    phoneRequiredHint: "* Único campo requerido",
    emailHint: "*Si indicas el email el cliente no tendrá que introducirlo",
    responsibleLabel: "Ingresa el nombre del responsable",
    responsiblePlaceholder: "Responsable de la reserva",
    scheduleLabel: "Programa la fecha de envío del enlace de check-in.",
    scheduleAuto: "Envió automático",
    schedule24: "24 horas antes del check-in",
    schedule48: "48 horas antes del check-in",
    schedule72: "72 horas antes del check-in",
    scheduleWeek: "Una semana antes del check-in",
    cancel: "Cancelar",
    complete: "Completar reserva",
  },
  payData: {
    errorNoPaymentRecord: "No se pudo identificar el registro de pago.",
    partialLinkGenerated: "Link de cobro generado correctamente.",
    errorGenerateLink: "No se pudo generar el link.",
    partialRegistered: "Pago parcial registrado.",
    errorSavePartial: "No se pudo guardar el pago parcial.",
    whatsappPartialMsg: "Hola {name}, te compartimos el link para completar el pago pendiente de tu reserva: {url}",
    errorInvoicingNotActive: "La facturación electrónica no está activada en tu plan.",
    fieldBillingProfile: "Perfil de facturación",
    fieldCountry: "País",
    fieldLegalName: "Razón social",
    fieldTaxId: "NIF/CIF/NIT",
    fieldAddressStreet: "Dirección",
    fieldAddressCity: "Ciudad",
    fieldAddressRegion: "Provincia",
    fieldAddressZip: "Código postal",
    fieldEmail: "Email",
    fieldIsActive: "Activar perfil",
    errorBillingIncomplete: "Completa tus datos de facturación. Faltan: {fields}",
    invoiceLinkCopied: "Link de facturación copiado.",
    reservationHasInvoice: "Esta reserva ya tiene factura.",
    errorLoadReceipt: "No se pudo cargar el recibo.",
    errorDownloadReceipt: "No se pudo descargar el recibo.",
    guestOutOfWindow: "El huésped está fuera de la ventana de 24h de WhatsApp.",
    errorSendReceipt: "Error al enviar el recibo.",
    charge: "Cargo",
    lodging: "Alojamiento",
    servicesExtras: "Servicios y extras",
    free: "Gratis",
    ivaIncluded: "(IVA {rate}% incluido)",
    includedInPrice: "(incluido en el precio)",
    pendingCharge: "Pendiente de cobro",
    viewBreakdown: "Ver desglose de precios",
    viewReceipt: "Ver recibo",
    receiptInfoPre: "Recibo informativo. La factura electrónica se emite desde la pestaña",
    chargesTab: "Cargos",
    receiptInfoNoInvoice: "Recibo informativo disponible. Para facturación electrónica, configura tus datos de facturación.",
    reservationNumber: "Reserva #{code}",
    currentStatus: "Estado actual",
    willChangeTo: "Cambiará a:",
    saving: "Guardando…",
    breakdownTitle: "Desglose de precios",
    discounts: "Descuentos",
    taxesAndFees: "Impuestos y tasas",
    ivaIncludedInPrice: "IVA ({rate}%) incluido en el precio: {amount}",
    includesTaxes: "Incluye {amount} de impuestos incluidos en el precio",
    total: "Total",
    close: "Cerrar",
    loadingReceipt: "Cargando recibo…",
    stayReceipt: "Recibo de estancia · {date}",
    downloadPdf: "Descargar PDF",
    sending: "Enviando…",
    sent: "¡Enviado!",
    outOfWindow: "Fuera de ventana 24h",
    sendWhatsapp: "Enviar por WhatsApp",
    stayDetail: "Detalle de la estancia",
    ivaIncludedShort: "IVA {rate}% incluido",
    discount: "Descuento",
    nightsCount: "noche | noches",
    additionalCharges: "Cargos adicionales",
    ivaShort: "IVA {rate}%",
    charged: "Cobrado",
    pending: "Pendiente",
    receiptGeneratedBy: "Recibo generado por",
    done: "Listo",
    registerPartial: "Registrar pago parcial",
    reservationTotal: "Total de la reserva",
    amountReceived: "Monto ya recibido",
    paid: "Abonado",
    pendingBalance: "Saldo pendiente",
    amountExceedsTotal: "El monto abonado supera el total. Usa el estado",
    paidStatus: "Pagado",
    internalNote: "Nota interna",
    optional: "(opcional)",
    notePlaceholder: "Ej: Primer pago recibido por transferencia...",
    autoLinkNote: "Al guardar, el link de pago se actualizará automáticamente a",
    cancel: "Cancelar",
    savePartial: "Guardar pago parcial",
    roomsCount: "{count} habitación | {count} habitaciones",
    groupNotePre: "Importe de la",
    groupNoteCombined: "reserva combinada",
    groupNoteMid: "desglose por habitación abajo.",
  },
};
